var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "form-block"
  }, [_c("div", {
    staticClass: "source"
  }, [_c("el-form", {
    ref: "ewayUpdateFromData",
    staticClass: "demo-form",
    attrs: {
      model: _vm.ewayUpdateFromData,
      "status-icon": "",
      rules: _vm.rules,
      "label-position": "left"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Upload E-way PDF",
      prop: "ewayUpdateFromData.ewayBillUrl"
    }
  }, [_c("file-upload", {
    attrs: {
      accept: ".pdf",
      "max-size": "1",
      "file-list": _vm.ewayBillUrl
    },
    on: {
      change: _vm.pdfUploaded
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Enter Eway No"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Enter Eway No",
      maxlength: "50"
    },
    model: {
      value: _vm.ewayUpdateFromData.ewayBillNo,
      callback: function ($$v) {
        _vm.$set(_vm.ewayUpdateFromData, "ewayBillNo", $$v);
      },
      expression: "ewayUpdateFromData.ewayBillNo"
    }
  })], 1), _c("el-form-item", [_c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }, {
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      type: "success"
    },
    on: {
      click: _vm.submitForm
    }
  }, [_vm._v(" Upload ")]), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      type: "reset"
    },
    on: {
      click: _vm.resetForm
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.reset")) + " ")])], 1)], 1)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };